import { StartupBurnerOverrideState, StartupBurnerState, TotalCoolingAir } from "models";
import { setTagValidity } from "utils/dampers.utils";
import { initialState } from "../initialState";
import { StartupBurnersActions } from "./StartupBurnerOverride.actions";

const setData = (state: StartupBurnerState, action: any) => {
  switch (action.type) {
    case StartupBurnersActions.UpdateValue:
      const { tag_name, update } = (action as any).payload;

      const newTags = state.tags.map((tag) => {
        if (tag.tag_name === tag_name) {
          return setTagValidity({ ...tag, ...update });
        }

        return setTagValidity(tag);
      });

      return { ...state, tags: newTags };
    case StartupBurnersActions.SetConfigs:
      const { data } = action.payload;
      const total_cooling_air = { ...state.total_cooling_air, value: data.total_cooling_air, newPosition: "" };

      return { ...data, total_cooling_air };

    case StartupBurnersActions.SetTotalCoolingAir:
      const { key, value } = action.payload;
      const totalCoolingAir = { ...state.total_cooling_air, [key]: value };

      return { ...state, total_cooling_air: totalCoolingAir };

    case StartupBurnersActions.FetchFailed:
      return { tags: [], total_cooling_air: { value: null, newPosition: null } };

    default:
      return state;
  }
};

const fetchingFailed = (state: boolean, action: any) => {
  switch (action.type) {
    case StartupBurnersActions.FetchFailed:
      return true;
    case StartupBurnersActions.SetConfigs:
    case StartupBurnersActions.FetchingConfigs:
      return false;
    default:
      return state;
  }
};

const setFetchingStatus = (state: boolean, action: any) => {
  switch (action.type) {
    case StartupBurnersActions.SetConfigs:
    case StartupBurnersActions.FetchFailed:
      return false;
    case StartupBurnersActions.FetchingConfigs:
      return true;
    default:
      return state;
  }
};

const setFetchTime = (state: string = "", action: any): string => {
  const fetchTime = action.payload?.fetchTime || "";

  switch (action.type) {
    case StartupBurnersActions.FetchingConfigs:
      return fetchTime;
    default:
      return state;
  }
};

const setFetchLine = (state: string | "", action: any): string => {
  switch (action.type) {
    case StartupBurnersActions.FetchingConfigs:
      return action.payload.fetchLineId;
    default:
      return state;
  }
};

export const startupBurnerOverrideReducer = (
  state: StartupBurnerOverrideState = initialState.startupBurnerOverride,
  action: any,
): StartupBurnerOverrideState => {
  switch (action.type) {
    case StartupBurnersActions.ToggleOverrideAll:
      const toggle = action.payload;
      const newDampers = state.data.tags.map((tag) => {
        return { ...tag, override: toggle };
      });

      const newTotalCoolingAir: TotalCoolingAir = { ...state.data.total_cooling_air, override: toggle };

      return { ...state, data: { ...state.data, tags: newDampers, total_cooling_air: newTotalCoolingAir }, overrideAll: toggle };
    default:
      return {
        fetching: setFetchingStatus(state.fetching, action as any),
        didInvalidate: fetchingFailed(state.didInvalidate, action as any),
        fetchTime: setFetchTime(state.fetchTime, action as any),
        fetchLine: setFetchLine(state.fetchLine, action as any),
        overrideAll: state.overrideAll,
        data: setData(state.data, action),
      };
  }
};
